module.exports = __webpack_public_path__ + "static/sport/title.a414b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/title.png
// module id = kT7F
// module chunks = 0